module.exports = __webpack_public_path__ + "img/121.f7cccc64.png";